import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import FormRadio from "../inputs/FormRadio";
import { Alert, Divider, Switch, Typography } from "antd";
import { FormInput, FormSelect } from "../inputs";
import NomineeList from "./NomineeList";
import DateInput from "../inputs/DateInput";
const { Text } = Typography;
const AdditionalInfo = ({
  next,
  back,
  mainData,
  dbAcc,
  crAcc,
  setMainData,
}) => {
  const { t } = useTranslation();

  const {
    control,
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      nominee: "availabel_nm",
    },
  });

  const onSubmit = (data) => {
    next();
  };
  const nominee = watch("nominee");
  const nomineeRelations = [
    { label: "Spouse", value: "spouse" },
    { label: "Child", value: "child" },
    { label: "Sibling", value: "sibling" },
    { label: "Parent", value: "parent" },
    { label: "Friend", value: "friend" },
    { label: "Other", value: "other" },
  ];

  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Non-binary", value: "non-binary" },
    { label: "Other", value: "other" },
    { label: "Prefer not to say", value: "prefer-not-to-say" },
  ];
  return (
    <div className="additional-info w50">
      <form className="ml3" onSubmit={handleSubmit(onSubmit)}>
        <h3>Additional Details</h3>
        <div className="pp-form-item">
          <FormSelect
            inline
            control={control}
            {...register("occupation")}
            errors={errors}
            label={t("Occupation")}
            options={[]}
            hideCreateOption={true}
          />
        </div>
        <div className="pp-form-item">
          <FormSelect
            inline
            control={control}
            required={true}
            options={[]}
            {...register("martial_status", {})}
            errors={errors}
            label={t("Marital Status")}
            hideCreateOption={true}
          />
        </div>

        <div className="pp-form-item">
          <FormInput
            control={control}
            required={true}
            {...register("father_first_name", {})}
            errors={errors}
            label={t("Father First Name")}
          />
        </div>
        <div className="pp-form-item">
          <FormInput
            control={control}
            required={true}
            {...register("father_middle_name", {})}
            errors={errors}
            label={t("Father Middle Name")}
          />
        </div>
        <div className="pp-form-item">
          <FormInput
            control={control}
            required={true}
            {...register("father_last_name", {})}
            errors={errors}
            label={t("Father Last Name")}
          />
        </div>
        <h3>Nominee Details</h3>
        <FormRadio
          control={control}
          options={[
            { label: "Available Nominees", value: "availabel_nm" },
            { label: "New Nominees", value: "new_nm" },
            { label: "No Nominees", value: "no_nm" },
          ]}
          {...register("nominee", {
            required: "Please select the nominee type.",
          })}
          errors={errors}
          defaultValue={"availabel_nm"}
          radio_name={"nominee"}
          label={""}
        />
        <br />
        {nominee === "availabel_nm" && <NomineeList />}
        {nominee === "new_nm" && (
          <div>
            <div className="pp-form-item">
              <FormSelect
                inline
                {...register("relation", {})}
                control={control}
                label={"Relation to First Applicant"}
                options={nomineeRelations}
                hideCreateOption
                placeholder={"Select Relation"}
              />
            </div>

            <div className="pp-form-item">
              <FormInput
                {...register("nominee_first_name", {})}
                control={control}
                label={"Nominee First Name"}
                placeholder={"Enter First Name"}
              />
            </div>

            <div className="pp-form-item">
              <FormInput
                {...register("nominee_middle_name", {})}
                control={control}
                label={"Nominee Middle Name"}
                placeholder={"Enter Middle Name"}
              />
            </div>

            <div className="pp-form-item">
              <FormInput
                {...register("nominee_last_name", {})}
                control={control}
                label={"Nominee Last Name"}
                placeholder={"Enter Last Name"}
              />
            </div>
            <div className="pp-form-item">
              <DateInput
                control={control}
                {...register("nominee_dob")}
                errors={errors}
                label={"Date of Birth"}
                dateFormat={["DD/MM/YYYY"]}
              />
            </div>
            <div className="pp-form-item">
              <FormSelect
                inline
                {...register("gender", {})}
                control={control}
                label={"Gender"}
                options={genderOptions}
                hideCreateOption
                placeholder={"Select Gender"}
              />
            </div>
            <div className="pp-form-item">
              <div className="d-flex align-center">
                {/* <Controller
              name="isSeniorCitizen"
              control={control}
              defaultValue={false}
              render={({ field }) => ( */}
                <Switch style={{ marginLeft: "8px", marginRight: "16px" }} />
                {/* )}
            /> */}
                <div className="d-flex flex-col">
                  <Text strong>
                    Is the Nominee’s current address the same as the First
                    Applicant’s address?
                  </Text>
                </div>
              </div>
            </div>
          </div>
        )}

        {nominee === "no_nm" && (
          <Alert
            message="No Nominee"
            description={
              <>
                <Typography.Paragraph>
                  I understand the advantages of adding nominee, however would
                  like to proceed without a nominee
                </Typography.Paragraph>
              </>
            }
            type="info"
            showIcon
            style={{ marginBottom: "20px" }}
          />
        )}

        <Divider />

        <h3>Detuct Tax</h3>
        <div className="d-flex align-center ">
          <Controller
            name="isSeniorCitizen"
            control={control}
            defaultValue={false}
            render={({ field }) => (
              <Switch
                {...field}
                // checked={field.value}
                onChange={(checked) => setValue("deduct_tax", checked)}
                style={{ marginLeft: "8px", marginRight: "16px" }}
              />
            )}
          />
          <div className="d-flex flex-col">
            <Text>Deduct Direct Tax</Text>
            <Text className="sm">(TDS to collect taxes at the source)</Text>
          </div>
        </div>

        <div className="mt3">
          <button type="button" className="back-btn mr2" onClick={() => back()}>
            Back
          </button>
          <button className="send-btn">Proceed</button>
        </div>
      </form>
    </div>
  );
};

export default AdditionalInfo;
